module.exports = __webpack_public_path__ + "img/rbtn.96b5bd06.png";